import CryptoJS from 'crypto-js';
const setCookie = function (name, value, timer) {
  let time = new Date();
  time.setTime(time.getTime() + timer * 60 * 1000);
  let expires = 'expires=' + time.toGMTString();
  document.cookie = name + '=' + value + '; ' + expires;
};

const getCookie = function (name) {
  name = name + '=';
  let cookie = document.cookie;
  let cookies = cookie.split(';');
  for (let item in cookies) {
    let value = cookies[item].trim();
    if (value.indexOf(name) === 0) {
      return value.slice(name.length, value.length);
    }
  }
  return '';
};

const getSign = function (path = '', method = '', date = '') {
  const host = 'account.zmrobo.com';
  const data = `${method} ${path} HOST ${host} DATE ${date} CLIENT`;
  const pathMd5 = CryptoJS.MD5(path).toString(CryptoJS.enc.Hex);
  const base64 = CryptoJS.HmacSHA256(data, pathMd5);
  const sign = CryptoJS.enc.Base64.stringify(base64);
  return sign;
};

export { getSign, setCookie, getCookie };
